import { isPlainObject } from '@/helpers/objectUtils.ts';

export function mergeIgnoringNulls<T extends object, U extends Partial<T>> (obj1: T, obj2: U): T {
    const merged = { ...obj1 };

    Object.keys(obj2).forEach((key) => {
        const k = key as keyof T;
        const val2 = obj2[k];
        const val1 = obj1[k];

        if (val2 === null) {
            return;
        }

        if (isPlainObject(val1) && isPlainObject(val2)) {
            merged[k] = mergeIgnoringNulls(val1, val2 as Partial<typeof val1>);
        } else {
            merged[k] = val2 as T[keyof T];
        }
    });

    return merged;
}
